import { ParsedUrlQuery } from 'querystring';

const getPublicWebsiteHref = (slug?: string, pageType?: string, query?: ParsedUrlQuery): string => {
  const { themeKey, draftId, isSample, isAdmin, layout } = query || {};

  let baseHref = `/wedding/${slug}`;
  if (isSample) baseHref = `/wedding-planning/website/sample/${themeKey}`;
  else if (isAdmin) baseHref = `/wedding-preview/${themeKey}`;

  const formattedPageType = pageType === 'home' ? '' : pageType;

  const getQueryParams = () => {
    const queryArr = [];
    if (draftId) {
      queryArr.push(`draftId=${draftId}`);
    }
    if (layout) {
      queryArr.push(`layout=${layout}`);
    }
    if (queryArr.length === 0) {
      return '';
    }
    return `?${queryArr.join('&')}`;
  };

  return `${baseHref}${formattedPageType ? `/${formattedPageType}` : ''}${getQueryParams()}`;
};

export default getPublicWebsiteHref;
